import React from 'react';

import { Button } from 'react-redux-app/lib/modules/button/components';

import themeCssJson from './styles/index.css.json';


export default props => <Button {...props} theme={themeCssJson} />;

export {
  themeCssJson
};
